module.exports = __webpack_public_path__ + "static/media/greenmask.ff788e9b.svg";